import PropTypes from 'prop-types';
import { useState } from 'react';
import { LoadingButton } from '@mui/lab';
import { dispatch } from '../../../../redux/store';
import { updateError } from '../../../../redux/slices/user';
import { askAdminAboutCall } from './useVoiceLines';

// For staff who can't set up phone lines: on a call whose line isn't set up
// (recording_reason "line_not_set_up"), tell the practice admins. The backend
// sends at most one alert per number per day, so a repeat press is harmless.
export default function AskAdminButton({ practiceId, callId, size = 'small', variant = 'outlined' }) {
    const [busy, setBusy] = useState(false);
    const [asked, setAsked] = useState(false);

    const ask = async () => {
        setBusy(true);
        const result = await askAdminAboutCall(practiceId, callId);
        setBusy(false);
        if (result.ok) {
            setAsked(true);
            dispatch(updateError({
                success: true,
                message: result.alreadyAsked ? 'An admin was already asked about this number today.' : 'Your practice admins have been asked to set up this line.',
            }));
        } else {
            dispatch(updateError({ success: false, message: result.message }));
        }
    };

    return (
        <LoadingButton size={size} variant={variant} loading={busy} disabled={asked} onClick={ask}>
            {asked ? 'Admin asked' : 'Ask an admin'}
        </LoadingButton>
    );
}

AskAdminButton.propTypes = {
    practiceId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    // `voice:<id>` or the numeric id.
    callId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    size: PropTypes.string,
    variant: PropTypes.string,
};
